// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupBlackListPopup__container-f0947c {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}

.GroupBlackListPopup__inner-container-e18e19 {
  padding: 16px 0;
  height: 100%;
}

.GroupBlackListPopup__info-block-df3bef {
  height: 100%;
}

.GroupBlackListPopup__placeholders-b78543 {
  padding: 8px 24px;
}

.GroupBlackListPopup__no-content-b661a6 {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/GroupBlackListPopup/GroupBlackListPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.inner-container {\n  padding: 16px 0;\n  height: 100%;\n}\n\n.info-block {\n  height: 100%;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n\n.no-content {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupBlackListPopup__container-f0947c`,
	"inner-container": `GroupBlackListPopup__inner-container-e18e19`,
	"innerContainer": `GroupBlackListPopup__inner-container-e18e19`,
	"info-block": `GroupBlackListPopup__info-block-df3bef`,
	"infoBlock": `GroupBlackListPopup__info-block-df3bef`,
	"placeholders": `GroupBlackListPopup__placeholders-b78543`,
	"no-content": `GroupBlackListPopup__no-content-b661a6`,
	"noContent": `GroupBlackListPopup__no-content-b661a6`
};
module.exports = ___CSS_LOADER_EXPORT___;
